import { render, staticRenderFns } from "./CreateAdmin.vue?vue&type=template&id=4ed37ce6"
import script from "./CreateAdmin.vue?vue&type=script&lang=js"
export * from "./CreateAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports